import request from "@/utils/request";
import { getToken } from "@/utils/auth";

export function loginByUsername(data) {
  return request({
    url: "/sport-manage/auth/user/login",
    method: "post",
    data,
  });
}

export function logout() {
  return request({
    url: "/sport-manage/auth/user/logout",
      method: "post",
      headers:{ 
        accessToken: getToken()
      }
    },
  );
}

export function getUserInfo() {
  return request({
    url: "/sport-manage/auth/user/info",
    method: "post"
  });
}
